module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sunCare@3x_fdc465.png";